import { render, staticRenderFns } from "./Guns.vue?vue&type=template&id=16849d90&scoped=true&"
import script from "./Guns.vue?vue&type=script&lang=js&"
export * from "./Guns.vue?vue&type=script&lang=js&"
import style0 from "./Guns.vue?vue&type=style&index=0&id=16849d90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16849d90",
  null
  
)

export default component.exports